import { capitalize } from 'lodash';

export function getVehicleLandingPageURL({
  category,
  seoMake,
  seoModel = null,
  seoTrim = null,
  seoYear = null
}) {
  return `/vehicle-${[category, seoMake, seoModel, seoYear, seoTrim]
    .filter(Boolean)
    .join('/')}`;
}

function interpolateField(field, aemField) {
  if (aemField !== '{{default}}') {
    if (field && !aemField) {
      return `${field} `;
    } else {
      return aemField ? `${aemField} ` : '';
    }
  } else {
    return field ? `${field} ` : '';
  }
}

export function formatCalloutTitle({
  category,
  make = null,
  model = null,
  title = '',
  trim = null,
  year = null
}) {
  const titleParts = title.split('/').filter(x => x !== '');

  const aemMake = interpolateField(make, titleParts[0]);
  const aemModel = interpolateField(model, titleParts[1]);
  const aemYear = interpolateField(year, titleParts[2]);
  const aemTrim = interpolateField(trim, titleParts[3]);

  return `${aemYear}${aemMake}${aemModel}${aemTrim} ${capitalize(
    category
  )}`.trim();
}
